export async function parseApiResponse(response) {
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  return {
    ...(data && typeof data === 'object' ? data : {}),
    ok: response.ok,
    status: response.status,
  };
}
